import React from 'react';
import BankDetailsFunctional from './components/bank-details-functional';
import './bank-details.scss';

const BankDetails = () => {
	return <BankDetailsFunctional />;
};
export default BankDetails;
